import React from "react";
import LegalPage from "components/Legal/LegalPage.jsx";

export default function DatenschutzPage() {
    return (
        <LegalPage title="Datenschutzerklärung">
            <h2>1. Verantwortlicher</h2>
            <p>
                Daniel Hackel
                <br />
                38229 Salzgitter
                <br />
                daniel.hackel@t-online.de
            </p>

            <h2>2. Allgemeine Hinweise</h2>
            <p>
                Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir verarbeiten
                personenbezogene Daten ausschließlich im Rahmen der geltenden
                Datenschutzvorschriften.
            </p>

            <h2>3. Server-Logfiles</h2>
            <p>
                Beim Aufruf dieser Website werden automatisch technische Informationen
                verarbeitet, insbesondere IP-Adresse, Datum und Uhrzeit des Zugriffs,
                Browserinformationen, Betriebssystem und aufgerufene Seiten.
            </p>

            <h2>4. Registrierung und Anmeldung</h2>
            <p>
                Wenn Sie sich registrieren oder anmelden, verarbeiten wir insbesondere
                Anmeldedaten, E-Mail-Adresse sowie weitere kontobezogene Informationen.
            </p>

            <h2>5. Nutzung der Plattform</h2>
            <p>
                Im Rahmen der Nutzung von kimat-online werden Nutzungsdaten, technische
                Metadaten und gegebenenfalls Eingaben verarbeitet, soweit dies für
                Betrieb, Sicherheit und Bereitstellung der Plattform erforderlich ist.
            </p>

            <h2>6. KI-gestützte Auswertung</h2>
            <p>
                Die Plattform verarbeitet öffentlich zugängliche Nachrichteninhalte
                automatisiert und KI-gestützt, um allgemeine Einschätzungen, Signale
                oder Klassifizierungen zu erzeugen. Es erfolgt keine individuelle
                Anlageberatung.
            </p>

            <h2>7. Cookies und lokale Speicherung</h2>
            <p>
                Es können technisch notwendige Cookies, Session-Daten sowie lokale
                Browser-Speicherungen wie LocalStorage verwendet werden, um Login,
                Einstellungen und die Funktionalität der Anwendung bereitzustellen.
            </p>

            <h2>8. Hosting</h2>
            <p>
                Diese Website wird bei technischen Dienstleistern gehostet. Soweit
                Cloud-Dienste wie Microsoft Azure eingesetzt werden, erfolgt die
                Verarbeitung auf Grundlage geeigneter vertraglicher Regelungen.
            </p>

            <h2>9. Speicherdauer</h2>
            <p>
                Personenbezogene Daten werden nur so lange gespeichert, wie dies für die
                jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten
                bestehen.
            </p>

            <h2>10. Rechte der betroffenen Personen</h2>
            <ul>
                <li>Recht auf Auskunft</li>
                <li>Recht auf Berichtigung</li>
                <li>Recht auf Löschung</li>
                <li>Recht auf Einschränkung der Verarbeitung</li>
                <li>Recht auf Datenübertragbarkeit</li>
                <li>Recht auf Widerspruch</li>
                <li>Recht auf Beschwerde bei einer Aufsichtsbehörde</li>
            </ul>

            <h2>11. Änderungen</h2>
            <p>Wir behalten uns vor, diese Datenschutzerklärung künftig anzupassen.</p>
        </LegalPage>
    );
}